import React from 'react';
import FaqReportingContainer from '@/client/components/FaqReporting/FaqReportingContainer';
import { FaqReportingProvider } from './context/FaqReportingContext';

const FaqReporting: React.FC<TSearchRequestObject> = ({ searchRequestObject }) => {
  return (
    <FaqReportingProvider searchRequestObject={searchRequestObject}>
      <FaqReportingContainer />
    </FaqReportingProvider>
  );
};

export default FaqReporting;
